import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { JSEncrypt} from 'jsencrypt';
import { Router, ActivatedRoute } from '@angular/router';
import { GeneralService } from '../general.service';
import * as GlobalVariables from '../global';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  constructor(private router: Router, @Inject(DOCUMENT) document, private route: ActivatedRoute,
  private homepageService: GeneralService, private snackBar: MatSnackBar, private authService: AuthService, private generalService: GeneralService,
  private spinn: NgxSpinnerService) { }
  role = sessionStorage.getItem('role');
  roleId = sessionStorage.getItem('roleId');
  districtId = sessionStorage.getItem('districtId');
  talukaId = sessionStorage.getItem('talukaId');
  chcId = sessionStorage.getItem('chcId');
  phcId = sessionStorage.getItem('phcId');
  facilityId = sessionStorage.getItem('facilityId');


  ngOnInit() {
    this.getFacilityData();  
    this.getTalukaData(); 
    this.getDistrictData();
  }


  fillForm() {
    if(this.authService.isLoggedIn()) {
      this.router.navigate(['fillform']);
    } else {
      this.authService.logout();
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['login']);
    }
  }

  

  addPatients() {
    
      this.router.navigate(['patientDataList']);
    
  }

  getFacilityData() {
  
      const input = {
        facilityId: this.facilityId
      };
      this.spinn.show();
      
      this.authService.getFacilityById(input).subscribe(response => {
        
          sessionStorage.setItem('hospitalName', response.json().hospitalName);
          sessionStorage.setItem('facilityTypeId', response.json().facilityTypeId);

          this.getfacilityTypeData(sessionStorage.getItem('facilityTypeId'));

          this.spinn.hide();
      }, (error) => {
          this.spinn.hide();
        this.snackBar.open(error.json().message, 'x', {
          duration: 5000,
        });
      });
    } 
  
  
  getDistrictData(){

    const input = {
      districtid: this.districtId
    };
    this.spinn.show();
    
    this.authService.getDistrictById(input).subscribe(response => {
        
        sessionStorage.setItem('district', response.json().district);

        this.spinn.hide();
    }, (error) => {
        this.spinn.hide();
      this.snackBar.open(error.json().message, 'x', {
        duration: 5000,
      });
    });
  }

  getTalukaData(){
  
    const input = {
      talukaid: this.talukaId
    };
    this.spinn.show();
    
    this.authService.getTalukaById(input).subscribe(response => {

      //console.log(response)
      
        sessionStorage.setItem('taluka', response.json().taluka);

        this.spinn.hide();
    }, (error) => {
        this.spinn.hide();
      this.snackBar.open(error.json().message, 'x', {
        duration: 5000,
      });
    });
  }
   
  getfacilityTypeData(facilityTypeID){
  
    const input = {
      facilityTypeId: facilityTypeID
    };
    this.spinn.show();
    
    this.authService.getFacilityTypeById(input).subscribe(response => {

        //console.log(response)
      
        sessionStorage.setItem('facilityType', response.json().facilityType);

        this.spinn.hide();
    }, (error) => {
        this.spinn.hide();
      this.snackBar.open(error.json().message, 'x', {
        duration: 5000,
      });
    });
  }

}


